import { GridColumn as Column } from '@progress/kendo-react-grid';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid } from 'src/components/shared/DataGrid/DataGrid';
import { DateTimeCell } from 'src/components/shared/DataGrid/DateCell';
import { ProductDetailDto, ProductLogDto } from 'src/store/products/product';
type Props = {
  product: Nullable<ProductDetailDto>;
};

export const Logs: React.FC<Props> = ({ product }) => {
  const [logs, setLogs] = useState<ProductLogDto[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (product) {
      setLogs(product.productLogs);
    }
  }, [product]);

  return (
    <DataGrid items={logs} filterable={false}>
      <Column
        field="regDate"
        title={t('props.date')}
        filterable={false}
        cell={props => <DateTimeCell {...props} />}
      />
      <Column field="productStatusName" title={t('productStatus.singular')} />
      <Column field="username" title={t('user.singular')} />
    </DataGrid>
  );
};
